<template>
  <div>
    <!-- Incoming call modal -->
    <div v-if="incomingCall==true && contentMinimized==false">
      <div class="row d-flex flex-row-reverse m-0">
        <div v-if="isNumeratorHidden==false" class="numeratorArea">
          <numerator :page="'numerator'"></numerator>
        </div>
        <div class="call_forward" v-if="isCallForwardHidden==false">
          <div class="forward-header">Çağrı Yönlendir</div>
          <div class="row m-0">
            <div class="col-md-7 personList">
              <div class="row m-0">Kişilere Yönlendir</div>
              <div></div>
              <div class="list-area scrollable-content">
                <div class="person d-flex justify-content-between align-items-center" v-for="(person, index) in sipAgents" :key="index">
                  <div>
                    <i v-if="person.status==='online'" class="fas fa-circle pr-2" style="color:#00B919;"></i>
                    <i v-if="person.status==='busy'" class="fas fa-circle pr-2" style="color:#DA0000;"></i>
                    <i v-if="person.status==='offline'" class="fas fa-circle pr-2" style="color:#828282;"></i>
                    <span>{{person.name}} ( {{person.privateIdentity}} )</span>
                  </div>
                  <div><span class="material-icons" @click="makeTransfer(person.privateIdentity ,person.status)" style="cursor:pointer;">phone_forwarded</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-5 numerator">
              <numerator :page="'forward'"></numerator>
            </div>
          </div>
        </div>
      </div>
      <div class="outgoing-call-box">
        <div class="row m-0">
          <div class="text-white p-0" style="background:#03B800; width:12px; height:120px;"></div>
          <div class="text-white py-1 px-2" style="width:688px; height:120px;">
            <div class="row m-0 pt-1 d-flex justify-content-end">
              <div class="call-head">
                <i class="fas fa-phone-alt"></i>
                <span v-if="callConfirmed!=true" class="pl-2 pr-3 f700">Aranıyor</span>
                <span v-else class="pl-2 pr-3 f700">{{durationLabel}}</span>
              </div>
              <i class="fas fa-compress-alt ml-2 py-1 pr-1" style="font-size:16px;" @click="minimizeContent('minimize')"></i>
            </div>
            <div class="row m-0">
              <div class="col-md-6" v-if="unknownNumber==false">
                <div class="f-26">{{incomingPhoneNumber}}</div>
                <div>
                  <span class="customerName">{{contactData.n}} {{contactData.sn}}</span>
                  <span v-if="contactData.jobTitle!==undefined" class="customerTitle ml-1">{{contactData.jobTitle}}</span>
                </div>
                <div v-if="contactData.organization!==undefined" class="customerOrganization">{{contactData.organization[0].name}}</div>
                <div v-else class="customerOrganization">Firma Yok</div>
              </div>
              <div class="col-md-6 mt-2" v-else>
                <div class="f-26">{{incomingPhoneNumber}}</div>
                <div>
                  <span class="customerName">Bilinmeyen Numara</span>
                </div>
              </div>
              <div class="col-md-6 icons-area d-flex flex-row-reverse">

                <div><span class="material-icons outgoing-icons end-call" @click="endCall('outgoing')">call_end</span></div>

                <div v-if="callConfirmed==true&&holdStatus==false"><span class="material-icons outgoing-icons" @click="holdCall()">phone_paused</span></div>
                <div v-if="callConfirmed==true&&holdStatus==true"><span class="material-icons outgoing-icons btn-active" @click="unholdCall()">phone_paused</span></div>

                <div v-if="callConfirmed==true"><span class="material-icons outgoing-icons" @click="isCallForwardHidden = !isCallForwardHidden,getAgentStatus()">phone_forwarded</span></div>

                <div v-if="callConfirmed==true"><span class="material-icons outgoing-icons" @click="isNumeratorHidden = !isNumeratorHidden">dialpad</span></div>

                <div v-if="muteStatus==false"><span class="material-icons outgoing-icons" @click="muteCall()"> mic_off </span></div>
                <div v-if="muteStatus==true"><span class="material-icons outgoing-icons btn-active" @click="unmuteCall()"> mic_off </span></div>

                <div v-if="callConfirmed==false"><span class="material-icons outgoing-icons" style="background:#35C677;" @click="answer">phone</span></div>

                <div>
                  <span class="material-icons outgoing-icons" data-toggle="dropdown" aria-expanded="false">more_vert</span>
                  <ul class="dropdown-menu mb-2 ml-2 p-0" style="z-index:1051;">
                    <li class="d-flex align-items-center p-3" data-toggle="modal" data-target="#addActivity" @click="clearModal=false">
                      <span class="material-icons">add_box</span>
                      <span class="ml-2">Aktivite Ekle</span>
                    </li>
                    <li v-if="unknownNumber==false" class="d-flex align-items-center p-3" @click="goDetail(contactData._id.$oid)">
                      <span class="material-icons">ballot</span>
                      <span class="ml-2">Detaya Git</span>
                    </li>
                    <li v-else class="d-flex align-items-center p-3" data-toggle="modal" data-target="#add" @click="clearModal=false,activaTabContact()">
                      <span class="material-icons">save</span>
                      <span class="ml-2">Numarayı Kaydet</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Outgoing call modal -->
    <div v-if="outgoingCall==true && unknownNumber==false && contentMinimized==false">
      <div class="row d-flex flex-row-reverse m-0">
        <div v-if="isNumeratorHidden==false" class="numeratorArea">
          <numerator :page="'numerator'"></numerator>
        </div>
        <div class="call_forward" v-if="isCallForwardHidden==false">
          <div class="forward-header">Çağrı Yönlendir</div>
          <div class="row m-0">
            <div class="col-md-7 personList">
              <div class="row m-0">Kişilere Yönlendir</div>
              <div class="list-area scrollable-content">
                <div class="person d-flex justify-content-between align-items-center" v-for="(person, index) in sipAgents" :key="index" >
                  <div>
                    <i v-if="person.status==='online'" class="fas fa-circle pr-2" style="color:#00B919;"></i>
                    <i v-if="person.status==='busy'" class="fas fa-circle pr-2" style="color:#DA0000;"></i>
                    <i v-if="person.status==='offline'" class="fas fa-circle pr-2" style="color:#828282;"></i>
                    <span>{{person.name}} ( {{person.privateIdentity}} )</span>
                  </div>
                  <div><span class="material-icons" @click="makeTransfer(person.privateIdentity ,person.status)" style="cursor:pointer;">phone_forwarded</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-5 numerator">
              <numerator :page="'forward'"></numerator>
            </div>
          </div>
        </div>
      </div>
      <div class="outgoing-call-box">
        <div class="row m-0">
          <div class="text-white p-0" style="background:#03B800; width:12px; height:120px;"></div>
          <div class="text-white py-1 px-2" style="width:688px; height:120px;">
            <div class="row m-0 pt-1 d-flex justify-content-end">
              <div class="call-head">
                <i class="fas fa-phone-alt"></i>
                <span v-if="callConfirmed!=true" class="pl-2 pr-3 f700">Aranıyor</span>
                <span v-else class="pl-2 pr-3 f700">{{durationLabel}}</span>
              </div>
              <i class="fas fa-compress-alt ml-2 py-1 pr-1" style="font-size:16px;" @click="minimizeContent('minimize')"></i>
            </div>
            <div class="row m-0">
              <div class="col-md-6">
                <div class="f-26">{{incomingPhoneNumber}}</div>
                <div>
                  <span class="customerName">{{contactData.n}} {{contactData.sn}}</span>
                  <span v-if="contactData.jobTitle!==undefined" class="customerTitle ml-1">{{contactData.jobTitle}}</span>
                </div>
                <div v-if="contactData.organization!==undefined" class="customerOrganization">{{contactData.organization[0].name}}</div>
                <div v-else class="customerOrganization">Firma Yok</div>
              </div>
              <div class="col-md-6 icons-area d-flex flex-row-reverse">

                <div><span class="material-icons outgoing-icons end-call" @click="endCall('outgoing')">call_end</span></div>

                <div v-if="callConfirmed==true&&holdStatus==false"><span class="material-icons outgoing-icons" @click="holdCall()">phone_paused</span></div>
                <div v-if="callConfirmed==true&&holdStatus==true"><span class="material-icons outgoing-icons btn-active" @click="unholdCall()">phone_paused</span></div>

                <div v-if="callConfirmed==true"><span class="material-icons outgoing-icons" @click="isCallForwardHidden = !isCallForwardHidden,getAgentStatus()">phone_forwarded</span></div>

                <div v-if="callConfirmed==true"><span class="material-icons outgoing-icons" @click="isNumeratorHidden = !isNumeratorHidden">dialpad</span></div>

                <div v-if="muteStatus==false"><span class="material-icons outgoing-icons" @click="muteCall()"> mic_off </span></div>
                <div v-if="muteStatus==true"><span class="material-icons outgoing-icons btn-active" @click="unmuteCall()"> mic_off </span></div>

                <div>
                  <span class="material-icons outgoing-icons" data-toggle="dropdown" aria-expanded="false">more_vert</span>
                  <ul class="dropdown-menu mb-2 ml-2 p-0" style="z-index:1051;">
                    <li class="d-flex align-items-center p-3" data-toggle="modal" data-target="#addActivity" @click="clearModal=false">
                      <span class="material-icons">add_box</span>
                      <span class="ml-2">Aktivite Ekle</span>
                    </li>
                    <li v-if="unknownNumber==false" class="d-flex align-items-center p-3" @click="goDetail(contactData._id.$oid)">
                      <span class="material-icons">ballot</span>
                      <span class="ml-2">Detaya Git</span>
                    </li>
                    <li v-else class="d-flex align-items-center p-3" data-toggle="modal" data-target="#add" @click="clearModal=false,activaTabContact()">
                      <span class="material-icons">save</span>
                      <span class="ml-2">Numarayı Kaydet</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Unknown Outgoing Call modal -->
    <div v-if="outgoingCall==true && unknownNumber==true && contentMinimized==false">
      <div class="row d-flex flex-row-reverse m-0">
        <div v-if="isNumeratorHidden==false" class="numeratorArea">
          <numerator :page="'numerator'"></numerator>
        </div>
        <div class="call_forward" v-if="isCallForwardHidden==false">
          <div class="forward-header">Çağrı Yönlendir</div>
          <div class="row m-0">
            <div class="col-md-7 personList">
              <div class="row m-0">Kişilere Yönlendir</div>
              <div class="list-area scrollable-content">
                <div class="person d-flex justify-content-between align-items-center" v-for="(person, index) in sipAgents" :key="index" >
                  <div>
                    <i v-if="person.status==='online'" class="fas fa-circle pr-2" style="color:#00B919;"></i>
                    <i v-if="person.status==='busy'" class="fas fa-circle pr-2" style="color:#DA0000;"></i>
                    <i v-if="person.status==='offline'" class="fas fa-circle pr-2" style="color:#828282;"></i>
                    <span>{{person.name}} ( {{person.privateIdentity}} )</span>
                  </div>
                  <div><span class="material-icons" @click="makeTransfer(person.privateIdentity ,person.status)" style="cursor:pointer;">phone_forwarded</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-5 numerator">
              <numerator :page="'forward'"></numerator>
            </div>
          </div>
        </div>
      </div>
      <div class="outgoing-call-box" >
        <div class="row m-0">
          <div class="text-white p-0" style="background:#03B800; width:12px; height:120px;"></div>
          <div class="text-white py-1 px-2" style="width:688px; height:120px;">
            <div class="row m-0 pt-1 d-flex justify-content-end">
              <div class="call-head">
                <i class="fas fa-phone-alt"></i>
                <span v-if="callConfirmed!=true" class="pl-2 pr-3 f700">Aranıyor</span>
                <span v-else class="pl-2 pr-3 f700">{{durationLabel}}</span>
              </div>
              <i class="fas fa-compress-alt ml-2 py-1 pr-1" style="font-size:16px;" @click="minimizeContent('minimize')"></i>
            </div>
            <div class="row m-0">
              <div class="col-md-6 mt-2">
                <div class="f-26">{{incomingPhoneNumber}}</div>
                <div>
                  <span class="customerName">Bilinmeyen Numara</span>
                </div>
              </div>
              <div class="col-md-6 icons-area d-flex flex-row-reverse mt-3">

                <div><span class="material-icons outgoing-icons end-call" @click="endCall('outgoing')">call_end</span></div>

                <div v-if="callConfirmed==true&&holdStatus==false"><span class="material-icons outgoing-icons" @click="holdCall()">phone_paused</span></div>
                <div v-if="callConfirmed==true&&holdStatus==true"><span class="material-icons outgoing-icons btn-active" @click="unholdCall()">phone_paused</span></div>

                <div v-if="callConfirmed==true"><span class="material-icons outgoing-icons" @click="isCallForwardHidden = !isCallForwardHidden,getAgentStatus()">phone_forwarded</span></div>

                <div v-if="callConfirmed==true"><span class="material-icons outgoing-icons" @click="isNumeratorHidden = !isNumeratorHidden">dialpad</span></div>

                <div v-if="muteStatus==false"><span class="material-icons outgoing-icons" @click="muteCall()"> mic_off </span></div>
                <div v-if="muteStatus==true"><span class="material-icons outgoing-icons btn-active" @click="unmuteCall()"> mic_off </span></div>

                <div>
                  <span class="material-icons outgoing-icons" data-toggle="dropdown" aria-expanded="false">more_vert</span>
                  <ul class="dropdown-menu mb-2 ml-2 p-0" style="z-index:1051;">
                    <li class="d-flex align-items-center p-3" data-toggle="modal" data-target="#addActivity">
                      <span class="material-icons">add_box</span>
                      <span class="ml-2">Aktivite Ekle</span>
                    </li>
                    <li v-if="unknownNumber==false" class="d-flex align-items-center p-3" @click="goDetail(contactData._id.$oid)">
                      <span class="material-icons">ballot</span>
                      <span class="ml-2">Detaya Git</span>
                    </li>
                    <li v-else class="d-flex align-items-center p-3" data-toggle="modal" data-target="#add" @click="clearModal=false,activaTabContact()">
                      <span class="material-icons">save</span>
                      <span class="ml-2">Numarayı Kaydet</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 

    <!-- Minimized Modal -->
    <div class="minimized-box" v-if="contentMinimized==true">
      <div class="row m-0 minimize-head">
        <span class="material-icons py-1 px-2" style="font-size:14px; background:#027A00;"> phone_callback </span>
        <span class="py-1 px-2">{{durationLabel}}</span>
      </div>
      <div class="row m-0 minimize-body">
        <div class="col-md-8 p-0" v-if="unknownNumber==false">
          {{contactData.n}} {{contactData.sn}}
        </div>
        <div class="col-md-8 p-0" v-else>
          Bilinmeyen Numara
        </div>
        <div class="col-md-4 p-0 d-flex">
          <span class="material-icons" data-toggle="dropdown" aria-expanded="false" style="font-size:18px; cursor:pointer;">more_vert</span>
          <ul class="dropdown-menu mb-2 ml-2 p-0">
            <li class="d-flex align-items-center p-3" data-toggle="modal" data-target="#addActivity" >
              <span class="material-icons">add_box</span>
              <span class="ml-2">Aktivite Ekle</span>
            </li>
            <li v-if="unknownNumber==false" class="d-flex align-items-center p-3" @click="goDetail(contactData._id.$oid)">
              <span class="material-icons">ballot</span>
              <span class="ml-2">Detaya Git</span>
            </li>
            <li v-else class="d-flex align-items-center p-3" data-toggle="modal" data-target="#add" @click="clearModal=false,activaTabContact()">
              <span class="material-icons">save</span>
              <span class="ml-2">Numarayı Kaydet</span>
            </li>
          </ul>
          <i class="fas fa-compress-alt m-auto" style="font-size:15px; cursor:pointer;" @click="minimizeContent('maximize')"></i>
        </div>
      </div>
    </div>

    <!-- New Activity Modal -->
    <div v-if="incomingCall || outgoingCall" class="modal fade" id="addActivity" ref="newActivity" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style="top:-15%;">
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
        <div class="modal-content">
          <newActivity :user="currentUser" :users="users" :clearModal="clearModal" :data="contactData" :sipData="true"></newActivity>
        </div>
      </div>
    </div>

    <!-- New Contact Modal -->
    <div class="modal fade" id="add" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style="top:-15%;">
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
        <div class="modal-content mcBgGrey">
          <newContact 
          ref="newContact"  
          :user="currentUser" 
          :clearModal="clearModal" 
          :isEditMode="isEditMode" 
          :data="contactData" 
          :users="this.users" 
          :customFieldArray="customFields"
          ></newContact>
        </div>
      </div>
    </div>
    <audio id="audio-player">
    <source src="@/assets/mixkit-marimba-ringtone-1359.wav" type="audio/mpeg">
    Your browser does not support the audio tag.
    </audio>
  </div>
</template>

<script>
 import JsSIP from 'jssip'
 import { markRaw } from 'vue'
 import { mapState } from 'vuex'
 import axios from 'axios'
 import {mapGetters} from 'vuex'
 import newActivity from '@/components/newActivity'
 import Numerator from './numerator.vue'
 import newContact from './newContact.vue'


export default {
  name: 'sip',
  components: {
    'newActivity':newActivity,
    'newContact':newContact,
    Numerator,
  },
  data() {
    return {
      sesion: null,
      options: null,
      configuration: {},
      ua: null,
      protocol: 'sip',
      socket: null,
      sessionStatus: 'Not initialized',
      session: null,
      audio: new window.Audio(),
      callAnswered:false,
      incomingCall:false,
      outgoingCall:false,
      incomingPhoneNumber:'',
      contacts:[],
      users:[],
      currentUser:[],
      organization:[],
      customFields:[],
      contactData:'',
      isDraggable:false,
      clearModal:false,
      unknownNumber: true,
      connected:false,
      isNumeratorHidden:true,
      isCallForwardHidden:true,
      callConfirmed:false,
      holdStatus:false,
      muteStatus:false,
      contentMinimized:false,
      isEditMode:false,
      callDataObj:{},
      time:0,
      timer_id:null,
      durationLabel:'00:00:00',
      intervalItem:null,
      sipAgents:[],
      agentData: {},
    }
  },

  computed: {
    ...mapState([
        'baseUrl',
    ]),
    ...mapGetters(['sipSettingsObj']),
  },

  created() {
    if (this.$root) {
      if (!this.$root.$refs || Object.isFrozen(this.$root.$refs) || !Object.isExtensible(this.$root.$refs)) {
        try {
          this.$root.$refs = {}
        } catch (e) {}
      }
      try {
        this.$root.$refs.sip = this
      } catch (e) {}
    }
  },

  methods: {
    refreshCallCenterAgents () {
      window.dispatchEvent(new CustomEvent('sip-agent-status-changed'))
    },
    setHeaderAgentStatus (status) {
      window.dispatchEvent(new CustomEvent('sip-agent-status-changed', {
        detail: { status: status }
      }))

      const header = this.$root && this.$root.$refs && this.$root.$refs.Header
      if (header) {
        header.agentStatus = status
      }
    },
    call(tel) {
      if(this.session == null){
        this.session = markRaw(this.ua.call(this.protocol + ':' + tel, this.options));
        if (this.session.connection) {
          console.log('Connection is valid')
          this.session.connection.addEventListener('addstream', e => {
            console.log('Add stream')
            this.audio.srcObject = e.stream
            this.audio.play()
          })

          this.session.on('addstream', function(e){
            const remoteAudio = this.audio
            remoteAudio.src = window.URL.createObjectURL(e.stream);
            remoteAudio.play();
          });
          this.session.connection.addEventListener('peerconnection', e => {
            console.log('Peer connection')
            this.audio.srcObject = e.stream
            this.audio.play()
          })
        } else {
          console.log('Connection is null')
        }
      } 
      else {
          alert("Çağrı sırasında başka bir arama yapılamaz.");
      }
    },
    rindapCallTask(tel,form) {
      if(this.session == null){
        this.session = markRaw(this.ua.call(this.protocol + ':' + tel, this.options));
        if (this.session.connection) {
          console.log('Connection is valid')
          this.session.connection.addEventListener('addstream', e => {
            console.log('Add stream')
            this.audio.srcObject = e.stream
            this.audio.play()
            form.reservationStatus= 'completed'
            this.$root.$refs.Header.updateRindapCallTaskF(form)
          })

          this.session.on('addstream', function(e){
            const remoteAudio = this.audio
            remoteAudio.src = window.URL.createObjectURL(e.stream);
            remoteAudio.play();
          });
          this.session.connection.addEventListener('peerconnection', e => {
            console.log('Peer connection')
            this.audio.srcObject = e.stream
            this.audio.play()
          })
        } else {
          console.log('Connection is null')
        }
      } 
    },
    answer() {
      this.session.answer(this.options)
      if (this.session.connection) {
        console.log('Connection is valid')

        this.session.connection.addEventListener('addstream', e => {
          console.log('Add stream')
          this.audio.srcObject = e.stream
          this.audio.play()
        })

        this.session.on('addstream', function(e){
          const remoteAudio = this.audio
          remoteAudio.src = window.URL.createObjectURL(e.stream);
          remoteAudio.play();
        });
        this.session.connection.addEventListener('peerconnection', e => {
          console.log('Peer connection')
          this.audio.srcObject = e.stream
          this.audio.play()
        })
        
      } else {
        console.log('Connection is null')
      }
    },
    dtmfSend(tone){
      var extraHeaders = [ 'X-Foo: foo', 'X-Bar: bar' ];

      var options = {
        'duration': 160,
        'interToneGap': 1200,
        'extraHeaders': extraHeaders
      };
      this.session.sendDTMF(tone, options);
    },
    makeTransfer(numberToTransfer, status) {
      let that = this 
      if(status === 'online'){
        let eventHandlers = {
          requestSucceeded: function (e) {
            console.log("Transfer succeeded");
          },
          requestFailed: function (e) {
            console.log("Transfer Failed");
            that.isNumeratorHidden=true
          },
          trying: function (e) {
            console.log("trying", e);
          },
          progress: function (e) {
            console.log("progress", e);
          },
          accepted: function (e) {
            console.log("accepted", e);
            that.isNumeratorHidden=true
          },
          failed: function (e) {
            console.log("failed", e);
          },
        };
        var options = {
          'eventHandlers'    : eventHandlers,
          'mediaConstraints' : { 'audio': true }
        };
        try {
          this.session.refer(numberToTransfer, options)
        } catch (err) {
          console.log("Error");
        }
      }
      else{
        alert('Kullanıcı şuanda çevrimiçi değil!')
      }
    },
    connect(data,type) {
      this.agentData = data
      // Create our JsSIP instance and run it:
      var socket = markRaw(new JsSIP.WebSocketInterface(data.wsUrl));
      var configuration = {
        sockets  : [ socket ],
        uri      : data.publicIdentity,
        password : data.password,
        realm    : data.realm,
        authorization_user: data.privateIdentity,
        session_timers_refresh_method: 'invite',
        pcConfig: {
          iceServers: [
            {
              urls: ['stun:stun.l.google.com:19302','stun:stun1.l.google.com:19302']
            }
          ]
        }
      };

      // JsSIP nesneleri değiştirilemez özellikler içerir. Vue 3'ün reaktif
      // Proxy'si ile sarmalanmaları bu özelliklerde Proxy hatasına yol açar.
      // Bu nedenle bu üçüncü taraf nesneleri reaktif durumun dışında tutuyoruz.
      this.configuration = markRaw(configuration)
      this.ua = markRaw(new JsSIP.UA(configuration));

      this.ua.start();
      this.ua.register();
      

      let that = this;

      this.ua.on('connected', function(e){ this.sessionStatus = 'connected'; 
        console.log("connected");
      });
      this.ua.on('disconnected', function(e){ this.sessionStatus = 'disconnected'; 
        console.log("disconnected");
        that.setAgentStatus('offline', data.id)
        that.stopInterval()
        that.setHeaderAgentStatus('offline')
        that.ua = null
      });
      this.ua.on('registered', function(e){ this.sessionStatus = 'registered'; 
        console.log("register oldu");
        if(type === 'onRefresh'){
          that.ua.unregister()
        }
        else {
          that.stopInterval()
          that.setAgentStatus('online', data.id).then(function (statusUpdated) {
            if (statusUpdated) {
              that.startInterval('online', data.id)
            }
          })
          that.setHeaderAgentStatus('online')
        }
        
      });
      this.ua.on('unregistered', function(e){ this.sessionStatus = 'unregistered';
        console.log("unregister oldu");
        that.stopInterval()
        that.setAgentStatus('busy', data.id).then(function (statusUpdated) {
          if (statusUpdated) {
            that.startInterval('busy', data.id)
          }
        })
        that.setHeaderAgentStatus('break')
      });
      this.ua.on('registrationFailed', function(e){ this.sessionStatus = 'registrationFailed'; 
        console.log("register failed");
        that.setHeaderAgentStatus('offline')
        alert('Bağlanılamadı!')
      });
      
      
      this.ua.on('newRTCSession', function(e){
        console.log('new RTC Session'); 
        that.isCallingFunc(e)
        that.sessionStatus = 'calling';
        that.session = markRaw(e.session);

        if(e.session._direction==="incoming"){
          that.session.on("progress",function(e){
            console.log("CALL in Progress");
          });
          that.session.on("confirmed",function(e){
            that.callDataObj.callStatus = 'answered'
            that.callConfirmed=true
            that.startTimer()
            that.toggleAudio("stop")
            that.break()
          });
          that.session.on("ended",function(e){
            console.log("Call Ended");
            that.incomingCall=false
            that.isNumeratorHidden=true
            that.session = null
            that.contentMinimized=false 
            that.connected=false
            that.callConfirmed=false
            that.stopTimer()
            that.callDataObj.callDuration = that.time
            that.time = 0
            that.timer_id = null
            that.upsertCallHistoryF()
            that.ua.register();
          });
          that.session.on("failed",function(e){
            console.log("call failed:" + e.cause);
            that.callDataObj.callStatus = 'not-answered'
            that.incomingCall=false
            that.callConfirmed=false
            that.session = null
            that.upsertCallHistoryF()
            that.toggleAudio("stop")
          });
        }
      });
      
      // Register callbacks to desired call events
      var eventHandlers = {
        'progress': function(e) {
          console.log('call is in progress');
          // that.break();
          console.log(e);
        },
        'failed': function(e) {
          console.log('call failed with cause: '+ e.cause);
          that.outgoingCall=false
          that.contentMinimized=false 
          that.session = null
          that.callDataObj.callStatus = 'not-answered'
          that.upsertCallHistoryF()
          // that.ua.register();
        },
        'ended': function(e) {
          console.log('call ended with cause: '+ e.cause);
          that.outgoingCall=false 
          that.contentMinimized=false 
          that.callConfirmed=false
          that.isCallForwardHidden=true
          that.isNumeratorHidden=true
          that.session = null
          that.stopTimer()
          that.callDataObj.callDuration = that.time
          that.time = 0
          that.timer_id = null
          that.upsertCallHistoryF()
          that.ua.register();
        },
        'confirmed': function(e) {
          console.log('call confirmed');
          console.log(e);
          that.callConfirmed=true
          that.callDataObj.callStatus = 'answered'
          that.startTimer()
          that.break()
        }
      };

      this.options = {
        'eventHandlers'    : eventHandlers,
        'mediaConstraints' : { 'audio': true }
      };
    },
    agentRegister(){ 
      if(this.ua == null){
        if(Object.keys(this.agentData).length === 0){
          this.setHeaderAgentStatus('offline')
        }
        else{
          this.connect(this.agentData)
        }
      }
      else{
        this.stopInterval()
        this.connect(this.agentData)
      }
    },
    break(){
      if(this.ua == null){
        this.setHeaderAgentStatus('offline')
      }
      else{
        this.ua.unregister()
      }
    },
    disconnect(){
      this.ua.stop()
    },
    setAgentStatus(status, id, shouldRefreshAgentList = true) {
      return axios({
        method:'POST',
        url:'/setSipAgentStatus',
        baseURL: this.baseUrl,
        data: {
          id: id,
          status: status,
          blockLoadingBar:true
        },
        withCredentials:true
      }).then((res)=>{
        if (res && res.data && res.data.status && res.data.status.code === '0') {
          if (shouldRefreshAgentList) {
            this.refreshCallCenterAgents()
          }
          return true
        }
        return false
      }).catch((error) => {
        console.log(error)
        return false
      })
    },
    isCallingFunc(data){
      if(data.session._direction==="incoming"){
        this.isCallForwardHidden = true
        this.isNumeratorHidden = true
        this.callDataObj.sipSettingsId = this.sipSettingsId
        this.callDataObj.callType = 'incoming'
        this.callDataObj.phoneNumber = data.request.from._display_name
        this.incomingCall = true
        this.incomingPhoneNumber = data.request.from._display_name
        this.getContacts(this.incomingPhoneNumber.slice(this.incomingPhoneNumber.length - 10))
        this.toggleAudio("play")
      }
      if(data.session._direction==="outgoing"){
        this.isCallForwardHidden = true
        this.isNumeratorHidden = true
        this.callDataObj.sipSettingsId = this.sipSettingsId
        this.callDataObj.callType = 'outgoing'
        this.callDataObj.phoneNumber = data.request.ruri._user
        this.incomingPhoneNumber = data.request.ruri._user
        this.outgoingCall = true
        this.getContacts(this.incomingPhoneNumber.slice(this.incomingPhoneNumber.length - 10))
      }
    },
    toggleAudio(action) {
      var audio = document.getElementById("audio-player");
      if (action === 'play') {
        audio.play();
      } else {
        audio.pause();
        audio.currentTime = 0
      }
    },
    getContacts(num) {
      this.unknownNumber=true
      this.contactData=""
      var params = {}
      let filterEnd={
        "searchMode":"contacts",
        "name":"default",
        "ands":[{
          fieldName: "gsm",
          filterType: "contacts",
          operator: "contains",
          value: num
        }]
      }
      params.filter=filterEnd
      params.pagingSize=30
      params.pagingOffset=0

      axios({
          method:'POST',
          url:'/getContacts',
          baseURL: this.baseUrl,
          data:params,
          withCredentials:true
      }).then((res)=>{
          return res
      }).then((res)=>{
          if(res && res.data && res.data.status && res.data.status.code==="0" && res.data.content){
            this.users=res.data.users
            this.currentUser=res.data.user
            this.contacts = Array.isArray(res.data.content.contacts) ? res.data.content.contacts : []
            this.customFields = res.data.content.customFields
            for(let i of this.contacts){
              if(i && i.gsm && Array.isArray(i.gsm)){
                for(let number of i.gsm){
                  if(number==this.incomingPhoneNumber.slice(this.incomingPhoneNumber.length - 10)){
                    this.contactData = i
                    this.unknownNumber=false
                    break
                  }
                }
              }
            }
          }else if(res && res.data && res.data.status && res.data.status.desc){
              this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: this.$ml.get('ERROR'),
                  text: res.data.status.desc
              })
          }
      })
    },
    upsertCallHistoryF() {
      var params = this.callDataObj

      axios({
          method:'POST',
          url:'/upsertCallHistory',
          baseURL: this.baseUrl,
          data:params,
          withCredentials:true
      }).then((res)=>{
          return res
      }).then((res)=>{
          if(res && res.data && res.data.status && res.data.status.code==="0"){
            this.callDataObj = {}
            if (this.$root && this.$root.$refs && this.$root.$refs.Header && this.$root.$refs.Header.callHistory) {
              this.$root.$refs.Header.callHistory()
            }
            this.time=0
          }else if(res && res.data && res.data.status && res.data.status.desc){
              this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: this.$ml.get('ERROR'),
                  text: res.data.status.desc
              })
          }
      })
    },
    getAgents(){
      axios({
        method:'POST',
        url:'/getCompanySipAgentsWithStatus',
        baseURL: this.baseUrl,
        data:{
          blockLoadingBar:true
        },
        withCredentials:true
      }).then((res)=>{
        return res
      }).then((res)=>{
        if(res && res.data && Array.isArray(res.data)){
          this.sipAgents = res.data
          for(let agent of res.data){
            if(agent && (agent.status==='online' || agent.status==='busy')){
              this.getSipSettingsF(agent.id, agent.status) 
              break
            }
          }
        }else if(res && res.data && res.data.status && res.data.status.desc){
          this.$notify({
            group: 'foo',
            type: 'error',
            title: this.$ml.get('ERROR'),
            text: res.data.status.desc
          })
        }
      }).catch(err => {
        console.log("getAgents error:", err)
      })
    },
    getAgentStatus(){
      axios({
        method:'POST',
        url:'/getCompanySipAgentsWithStatus',
        baseURL: this.baseUrl,
        data:{
          blockLoadingBar:true
        },
        withCredentials:true
      }).then((res)=>{
        return res
      }).then((res)=>{
        if(res && res.data && Array.isArray(res.data)){
          this.sipAgents = res.data
        }
      }).catch(err => {
        console.log("getAgentStatus error:", err)
      })
    },
    getSipSettingsF(id, status){
      axios({
        method:'POST',
        url:'/getSipSettings',
        baseURL: this.baseUrl,
        withCredentials:true
      }).then((res)=>{
        return res
      }).then((res)=>{
        if(res.data.status.code==="0"){
          for(let agent of res.data.content.settings){
            if(agent._id.$oid === id){
              let data = {}

              data.id = agent._id.$oid
              data.name = agent.name
              data.password = agent.password
              data.privateIdentity = agent.privateIdentity
              data.publicIdentity = agent.publicIdentity
              data.realm = agent.realm
              data.sipOutboundUrl = agent.sipOutboundUrl
              data.wsUrl = agent.wsUrl
              if(status === 'online'){
                this.connect(data)
              }
              else{
                this.connect(data, "onRefresh")
              }
            }
          }
        }else{
          this.$notify({
            group: 'foo',
            type: 'error',
            title: this.$ml.get('ERROR'),
            text: res.data.status.desc
          })
        }
      })
    },
    goDetail(id){
      this.$router.push('/contactCard/' + id)
    },
    endCall(type){
      
      this.session.terminate()
      this.incomingCall=false
      this.outgoingCall=false
      this.callConfirmed=false
      this.connected=false
      this.session=null
    },
    holdCall(){
      this.session.hold()
      this.holdStatus=true
      this.stopTimer()
    },
    unholdCall(){
      this.session.unhold()
      this.holdStatus=false
      this.startTimer()
    },
    muteCall(){
      this.muteStatus=true
      this.session.mute()
    },
    unmuteCall(){
      this.muteStatus=false
      this.session.unmute()
    },
    minimizeContent(type){
      if(type === 'minimize'){
        this.contentMinimized = true
      }
      else{
        this.contentMinimized = false
      }
      this.$emit("minimize", type)
    },
    startTimer(){
      var that = this
      this.timer_id = setInterval(function(){
        if(that.time < 86400){
          that.time++;
          that.generateTime();
        }
      }, 1000);
    },
    stopTimer(){
      clearInterval(this.timer_id);
    },
    generateTime(){
      var second = this.time % 60;
      var minute = Math.floor(this.time / 60) % 60;
      var hour = Math.floor(this.time / 3600) % 60;
      
      second = (second < 10) ? '0'+second : second;
      minute = (minute < 10) ? '0'+minute : minute;
      hour = (hour < 10) ? '0'+hour : hour;

      this.durationLabel = hour + ':' + minute + ':' + second
    },
    startInterval(type, agent){
      var self = this
      this.intervalItem = setInterval(function(){
        self.setAgentStatus(type, agent, false)
      }, 7000);
    },
    stopInterval(){
      clearInterval(this.intervalItem)
      this.intervalItem = null
    },
    activityModalHidden(){
      let statu=false
      this.$store.dispatch('editLineStatu', statu)
      this.clearModal=true
    },
    modalHidden(){
      this.isEditMode=false
      // this.contactData = {}
      this.$refs.newContact.clear()
    },
    activaTabContact(){
      this.$root.$refs.newContact.activaTabContact()
    },
    
  },


  mounted() {
    $(this.$refs.newActivity).on("hidden.bs.modal", this.activityModalHidden)
    $(this.$refs.vuemodal).on("hidden.bs.modal", this.modalHidden)
    this.getAgents()
  },
  watch:{
    outgoingCall: function(){
      if(this.outgoingCall==true){
        this.$emit("isOnCalling",true)
      }
      else{
        this.$emit("isOnCalling",false)
      }
    },
    incomingCall: function(){
      if(this.incomingCall==true){
        this.$emit("isOnCalling",true)
      }
      else{
        this.$emit("isOnCalling",false)
      }
    }
  }
}
</script>

<style scoped>
  @import url("https://fonts.googleapis.com/icon?family=Material+Icons");

  .sipContent {
    max-width: 840px;
    min-width: 700px;
    margin: auto; 
  }
  .f700 {
    font-weight: 700;
  }
  .body-content {
    height: 125px;
    background: #333333;
    position: relative;
  }
  .bgGreen {
    background: #03B800;
    min-width: 650px;
    font-size: 16px;
    line-height: 19px;
    font-weight: 500;
  }
  .bgDarkGreen {
    background: #014A00;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
  }
  .bgDark {
    background: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32.5px;
    cursor: pointer;
  }
  .f-26 {
    color: white;
    font-size: 24px;
    font-weight: 700;
  }
  .f-20 {
    font-size: 20px;
    font-weight: 500;
  }
  .f-15 {
    color: white;
    font-size: 15px;
    line-height: 18px;
    font-weight: 400;
  }
  .customerTitle{
    background: #262626;
    border-radius: 4px;
    font-size: 13px;
    line-height: 24px;
    padding: 3px 10px;
  }
  .customerName {
    font-weight: 500;
    font-size: 16px;
  }
  .customerOrganization {
    font-weight: 400;
    font-size: 14px;
    color: #C5C5C5;
  }
  .icon {
    position: absolute;
    font-size: 28px;
    border-radius: 25px;
    color: white;
    top: -50%;
  }
  .phone {
    background: #35C677;
    right: 35%;
    padding: 0.6rem;
  }
  .phone:hover {
    background: #289459;
    cursor: pointer;
  }
  .micOff {
    background: transparent;
    border: 2px solid #F2F2F2;
    color: #F2F2F2;
    right: 21%;
    padding: 0.5rem;
  }
  .micOff:hover {
    border: 2px solid #BFBFBF;
    color: #BFBFBF;
    cursor: pointer;
  }
  .micOff-slash {
    background: #F2F2F2;
    border: 2px solid #F2F2F2;
    color: #333333;
    right: 21%;
    padding: 0.5rem;
  }
  .callEnd {
    background: #F93E29;
    right: 7%;
    padding: 0.6rem;
    cursor: pointer;
  }
  .phone_forwarded {
    background: transparent;
    border: 2px solid #60B8FA;
    color: #60B8FA;
    right: 21%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .phone_forwarded:hover {
    border: 2px solid #4C92C7;
    color: #4C92C7;
  }
  .phone_forwarded-slash {
    background: #60B8FA;
    border: 2px solid #60B8FA;
    color: #333333;
    right: 21%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .phone_paused {
    background: transparent;
    border: 2px solid #F2DA00;
    color: #F2DA00;
    right: 35%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .phone_paused:hover {
    background: transparent;
    border: 2px solid #BFAC00;
    color: #BFAC00;
  }
  .phone_paused-slash {
    background: #F2DA00;
    border: 2px solid #F2DA00;
    color: #333333;
    right: 35%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .micOff-connected {
    background: transparent;
    border: 2px solid #F2F2F2;
    color: #F2F2F2;
    right: 49%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .micOff-connected:hover {
    border: 2px solid #BFBFBF;
    color: #BFBFBF;
  }
  .micOff-connected-slash {
    background: #F2F2F2;
    border: 2px solid #F2F2F2;
    color: #333333;
    right: 49%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .dialpad {
    background: transparent;
    border: 2px solid #F2F2F2;
    color: #F2F2F2;
    right: 63%;
    padding: 0.5rem;
    cursor: pointer;
  }
  .dialpad:hover {
    border: 2px solid #BFBFBF;
    color: #BFBFBF;
  }
  .dialpad-slash {
    background: #F2F2F2;
    border: 2px solid #F2F2F2;
    color: #333333;
    right: 63%;
    padding: 0.5rem;
    cursor: pointer;
  }


  .whiteBtn {
    background: #F2F2F2;
    border-radius: 24px;
    border: none;
    padding: 6px 20px;
  }
  .numerator {
    padding: 0;

  }
  .numeratorArea{
    z-index: 1051;
  }
  .call_forward {
    margin: 0;
    width: 580px;
    background: #333333;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    z-index: 1051;
  }
  .forward-header {
    text-align: center;
    padding: 0.75rem;
    color: #F2F2F2;
    font-size: 20px;
    font-weight: 700;
    background: #0D0D0D;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .personList{
    background: #242424;
    padding: 0;
    margin: 0;
    border-right: 1px solid #4F4F4F;
  }
  .personList .row {
    padding: 1.2rem 1rem;
    border-bottom: 1px solid #4F4F4F;
    font-size: 20px;
    font-weight: 700;
    color: #FFFFFF;
  }
  .forward-btn {
    margin: 0rem auto 1rem auto;
    background: #1991EB;
    padding: 0.5rem 4rem;
    border-radius: 30px;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
  }

  .person {
    padding: .7rem;
    border-bottom: 1px solid #333333;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 700;
  }
  .outgoing-call-box {
    width: 700px;
    background: #333333;
    height: 120px;
  }
  .call-head {
    background: #02AE00;
    border-radius: 4px;
  }
  .fa-phone-alt {
    padding: 0.3rem;
    background: #027A00;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .icons-area {
    display: flex;
    justify-content: end;
    align-items: center;
  }
  .outgoing-icons {
    background: #4D4D4D;
    padding: 0.6rem;
    border-radius: 50%;
    margin-left: 0.5rem;
    cursor: pointer;
  }
  .outgoing-icons:hover {
    background: #838383;
  }
  .btn-active{
    background: #F2F2F2;
    color: #333333;
  }
  .icon-active{
    background: #F2F2F2;
    padding: 0.6rem;
    border-radius: 50%;
    margin-left: 0.5rem;
    color: #333333;
    cursor: pointer;
  }
  .icon-active-mic{
    background: #F2F2F2;
    padding: 0.6rem;
    border-radius: 50%;
    margin-left: 0.5rem;
    color: #333333;
    cursor: pointer;
  }
  .end-call {
    background: #F93E29;
  }
  .end-call:hover {
    background: #ec0000;
  }
  .minimized-box{
    position: absolute;
    width: 200px;
    background: red;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
  }
  .minimize-head {
    background: #02AE00;
  }
  .minimize-body {
    background: #333333;
    padding: 0.7rem 0.5rem;
  }
  ul {
    border-radius: 8px;
    min-width: 200px;
  }
  li {
    cursor: pointer;
    color: #53565E;
    font-weight: 400;
    border-bottom: 1px solid #E0E0E0;
  }
  li:hover {
    background: #e0e0e0;
  }
  .modal {
    pointer-events: none;
  }
  .scrollable-content {
    box-sizing: border-box;
    height: 350px;
    overflow-y: scroll;
  }
    /* Hide scrollbar for Chrome, Safari and Opera */
  .scrollable-content::-webkit-scrollbar {
      display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  .scrollable-content {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  
</style>
